import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import { SvgArrow } from 'components/Svgs';

import './PageTurner.scss';

const messages = defineMessages({
  xThroughyOfz: {
    id: 'page-turner.x-through-y-of-z',
    defaultMessage: '{startNumber, number} - {endNumber, number} of {count, number}',
  },
});

const PageTurner = ({
  children,
  className,
  rightSideContent,

  count,
  endNumber,
  isLoading,
  viewNextPage,
  viewPrevPage,
  isOnFirstPage,
  isOnLastPage,
  startNumber,
}) => {
  if (!count) return null;
  return (
    <div className={withMods('page-turner', className)}>
      <div className="page-turner__item-group">{children}</div>
      <div className="page-turner__item-group">
        {rightSideContent}
        <div className="page-turner__controls">
          {!isLoading && (
            <Message
              className="text--sm page-turner__text"
              message={messages.xThroughyOfz}
              values={{
                startNumber,
                endNumber,
                count,
              }}
            />
          )}
          <button type="button" className="page-turner__button" disabled={isOnFirstPage} onClick={viewPrevPage}>
            <SvgArrow theme={isOnFirstPage ? 'disabled' : 'brand'} direction="left" />
          </button>
          <button type="button" className="page-turner__button" disabled={isOnLastPage} onClick={viewNextPage}>
            <SvgArrow theme={isOnLastPage ? 'disabled' : 'brand'} direction="right" />
          </button>
        </div>
      </div>
    </div>
  );
};

PageTurner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  rightSideContent: PropTypes.node,
  count: PropTypes.number,
  endNumber: PropTypes.number,
  isLoading: PropTypes.bool,
  viewNextPage: PropTypes.func,
  viewPrevPage: PropTypes.func,
  isOnFirstPage: PropTypes.bool,
  isOnLastPage: PropTypes.bool,
  startNumber: PropTypes.number,
};

export default PageTurner;
